import { __decorate } from "tslib";
import { AutoEncoder, DateDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
export class WebshopTicketsQuery extends AutoEncoder {
}
__decorate([
    field({ decoder: StringDecoder, optional: true })
], WebshopTicketsQuery.prototype, "lastId", void 0);
__decorate([
    field({ decoder: DateDecoder, optional: true })
], WebshopTicketsQuery.prototype, "updatedSince", void 0);
//# sourceMappingURL=WebshopTicketsQuery.js.map